module.exports = __webpack_public_path__ + "img/en_3.92db7916.jpg";